<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-select
            :items="formatCategories"
            label="Type"
            v-model.trim="doc.format"
            :rules="[(v) => !!v || 'Format is required']"
            required
          ></v-select>

          <v-select
            :items="physicalCategories"
            label="Format"
            v-model.trim="doc.physical"
            v-if="doc.format == 'Physical'"
          ></v-select>

          <v-select
            :items="digitalCategories"
            label="Format"
            v-model.trim="doc.digital"
            v-if="doc.format == 'Digital'"
          ></v-select>

          <v-select
            :items="stageCategories"
            label="Type"
            v-model.trim="doc.stage"
            :rules="[(v) => !!v || 'Stage is required']"
            required
          ></v-select>

          <v-text-field
            class="mt-5"
            label="Location"
            v-model.trim="doc.location"
            type="text"
            placeholder="Location"
            id="location"
            required
          ></v-text-field>

        </v-col>
        <v-col cols="12">
          <v-tabs dark>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">En</v-tab>
            <v-tab href="#tab-2">Fr</v-tab>
            <v-tab href="#tab-3">Ar</v-tab>

            <v-tab-item value="tab-1">
              <v-text-field
                class="mt-5"
                label="Title"
                v-model.trim="doc.title_en"
                type="text"
                placeholder="doc"
                id="title_en"
              ></v-text-field>
              <v-textarea
                label="Description"
                v-model.trim="doc.description_en"
                type="text"
                placeholder="Description"
                id="description_en"
              ></v-textarea>
            </v-tab-item>

            <v-tab-item value="tab-2">
              <v-text-field
                class="mt-5"
                label="Titre"
                v-model.trim="doc.title_fr"
                type="text"
                placeholder="Titre"
                id="title_fr"
              ></v-text-field>
              <v-textarea
                label="Description"
                v-model.trim="doc.description_fr"
                type="text"
                placeholder="La description"
                id="description_fr"
              ></v-textarea>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-text-field
                class="mt-5"
                label="عنوان"
                v-model.trim="doc.title_ar"
                type="text"
                placeholder="عنوان"
                id="title_ar"
              ></v-text-field>
              <v-textarea
                label="وصف"
                v-model.trim="doc.description_ar"
                type="text"
                placeholder="وصف"
                id="description_ar"
              ></v-textarea>
            </v-tab-item>
          </v-tabs>
        </v-col>

        <v-col cols="6">


          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Title</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in pictos" :key="item.id">
                  <td>{{ item.title_en }}</td>
                  <td>
                    <v-switch
                      v-model="item.selected"
                      @change="selectItem(pictos, item.id)"
                      class="ma-2"
                    ></v-switch>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="6">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Title</th>
                  <th class="text-left">Icon</th>
                </tr>
              </thead>
              <tbody>
                <draggable
                  :list="shortlist"
                  :sort="true"
                  ghost-class="ghost"
                  @start="startDrag()"
                  @end="endDrag()"
                  ref="pictos"
                  id="pictos"
                >
                  <tr
                    v-for="item in shortlist"
                    :key="item.id"
                    :data-id="item.id"
                  >
                    <td>{{ item.title_en }}</td>
                    <td><img :src="item.src" class="img-icon" /></td>
          
                  </tr>
                </draggable>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import draggable from "vuedraggable";
import lodash from "lodash";

export default {
  name: "UserPictoForm",
  data() {
    return {
      isValid: true,
      pictos: null,
      shortlist: [],
      physicalCategories: ["Info", "Totem", "A2", "A3"],
      digitalCategories: ["Email", "Web", "Social"],
      formatCategories: ["Digital", "Physical"],
      stageCategories: ["Planning", "Arrival", "Orient", "Explore", "Leave"],
    };
  },
  props: {
    doc: Object,
  },
  components: {
    draggable,
  },
  mounted() {
    this.loadPictos();
  },
  computed: {
    selectedPictos() {
      if (this.pictos) {
        return this.pictos.filter((item) => item.selected === true);
      } else {
        return [];
      }
    },
  },
  watch: {
    shortlist(val) {
      this.$set( this.doc, 'pictos', val )
    },
    doc: {
      deep: true,
      handler(val) {
        console.log("doc", val);
      },
    },
  },
  methods: {
    loadPictos() {
      console.log("load pictos");
      fb.pictosCollection
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          let count = 0;
          this.pictos = items;
          this.pictos.forEach((item) => {
            item.selected = this.checkId(this.doc.pictos, item.id);
            item.index = count;
          });
          this.createShortlist();
        })
        .catch(() => {});
    },
    checkId(arr, id) {
      let filteredList = arr.filter((item) => item.id == id);
      return filteredList.length >= 1 ? true : false;
    },
    selectItem(arr, id) {
      let vm = this;
      let item = arr.find((item) => item.id === id);
      let indexOfItem = arr.indexOf(item);
      vm.$set(arr, indexOfItem, item);
      this.updateShortList(item);
    },

    startDrag() {
      this.dragging = false;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById("pictos");
      div.children.forEach((doc) => {
        let item = this.shortlist.find((x) => x.id === doc.dataset.id);
        let indexOfItem = this.shortlist.indexOf(item);
        item.index = count;
        vm.$set(vm.shortlist, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },
    createShortlist() {
      let l = this.pictos.filter((item) => item.selected == true);
      this.shortlist = lodash.orderBy(l, "index", "asc");
    },
    updateShortList(item) {
      if (item.selected == true) {
        item.index = this.shortlist.length;
        this.shortlist.push(item);
      } else {
        let ref = this.shortlist.find((x) => x.id === item.id);
        let indexOfItem = this.shortlist.indexOf(ref);
        this.shortlist.splice(indexOfItem, 1);
      }
    },
  },
};
</script>
